export default "__VITE_ASSET__CsN6TsFP__"